import { useEffect, useState } from "react";
import { Download, Share, X, Smartphone } from "lucide-react";

const KEY = "sb_install_prompt_dismissed";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export default function InstallPrompt() {
  const [show, setShow] = useState(false);
  const [deferredEvent, setDeferredEvent] = useState(null);
  const [platform, setPlatform] = useState("other");

  useEffect(() => {
    if (localStorage.getItem(KEY) || isStandalone()) return;

    if (isIOS()) {
      setPlatform("ios");
      const t = setTimeout(() => setShow(true), 2500);
      return () => clearTimeout(t);
    }

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferredEvent(e);
      setPlatform("android");
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferredEvent) return;
    deferredEvent.prompt();
    await deferredEvent.userChoice;
    dismiss();
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-prompt-banner"
      className="fixed left-4 right-4 bottom-36 md:left-6 md:right-auto md:bottom-6 md:max-w-sm z-40 sb-card rounded-lg p-4 sb-fade-up"
    >
      <div className="flex items-start justify-between mb-2">
        <p className="text-sm font-display font-bold inline-flex items-center gap-1.5">
          <Smartphone size={15} style={{ color: "var(--sb-primary)" }} /> Add to Home Screen
        </p>
        <button data-testid="install-prompt-dismiss" onClick={dismiss} className="opacity-60 hover:opacity-100">
          <X size={16} />
        </button>
      </div>

      {platform === "ios" ? (
        <p className="text-xs leading-relaxed" style={{ color: "var(--sb-text-secondary)" }}>
          Tap the <Share size={12} className="inline -mt-0.5" style={{ color: "var(--sb-primary)" }} /> Share icon
          below, then <strong style={{ color: "var(--sb-text)" }}>"Add to Home Screen"</strong> — keep Stats Betting one
          tap away, no App Store needed.
        </p>
      ) : (
        <>
          <p className="text-xs leading-relaxed mb-3" style={{ color: "var(--sb-text-secondary)" }}>
            Install StatsBet on your phone for football news and bookmaker offers — no App Store needed.
          </p>
          <button
            data-testid="install-prompt-install-btn"
            onClick={install}
            className="sb-btn-primary w-full py-2.5 text-xs uppercase tracking-wider inline-flex items-center justify-center gap-2"
          >
            <Download size={14} /> Install App
          </button>
        </>
      )}
    </div>
  );
}
